export default (state={}, action ) => {
    switch(action.type)
    {
        case 'SET_STATE_CHART':
            return action.payload;
        default: return state;

    }
}